var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{ref:"scroll",staticClass:"container section scrollspy",attrs:{"id":"Servicios"}},[_c('div',{staticClass:"row"},[_c('description'),_c('tabs')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }